/**
 * Renders Static Component when no dealership is found
 */

import { StyledDiv } from './NoDealershipAccess.style';

const NoDealershipAccess: React.FC = () => {
    return (
        <StyledDiv>
            <h1>No Dealership Found</h1>
            <p data-testid="no-dealership-access">
                You currently do not have access to any dealerships. Please contact your system administrator to request access or
                verify permissions.
            </p>
        </StyledDiv>
    );
};

export default NoDealershipAccess;
